import __pb_dep_0 from "google-protobuf";
import __pb_dep_1 from "./IM.BaseDefine_pb.js";

const __pbDeps = {
  "google-protobuf": __pb_dep_0,
  "./IM.BaseDefine_pb.js": __pb_dep_1,
};

const __pbModule = { exports: {} };
const exports = __pbModule.exports;
const module = __pbModule;

const require = (specifier) => {
  const resolved = __pbDeps[specifier];
  if (!resolved) {
    throw new Error(`Unsupported protobuf dependency in IM.Profile_pb.js: ${specifier}`);
  }
  return resolved;
};

(function runGeneratedProtobufModule() {
  const root = globalThis;
  root.proto ??= {};
  var proto = root.proto;
  var COMPILED = false;

// source: IM.Profile.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck
var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();
var IM_BaseDefine_pb = require('./IM.BaseDefine_pb.js');
goog.object.extend(proto, IM_BaseDefine_pb);
goog.exportSymbol('proto.IM.Profile.IMUserProfileChangedNotify', null, global);
goog.exportSymbol('proto.IM.Profile.IMUserProfileSyncReq', null, global);
goog.exportSymbol('proto.IM.Profile.IMUserProfileSyncRsp', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Profile.IMUserProfileSyncReq = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Profile.IMUserProfileSyncReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Profile.IMUserProfileSyncReq.displayName = 'proto.IM.Profile.IMUserProfileSyncReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Profile.IMUserProfileSyncRsp = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, proto.IM.Profile.IMUserProfileSyncRsp.repeatedFields_, null);
};
goog.inherits(proto.IM.Profile.IMUserProfileSyncRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Profile.IMUserProfileSyncRsp.displayName = 'proto.IM.Profile.IMUserProfileSyncRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IM.Profile.IMUserProfileChangedNotify = function(opt_data) {
    jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IM.Profile.IMUserProfileChangedNotify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
    /**
   * @public
   * @override
   */ proto.IM.Profile.IMUserProfileChangedNotify.displayName = 'proto.IM.Profile.IMUserProfileChangedNotify';
}
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Profile.IMUserProfileSyncReq.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Profile.IMUserProfileSyncReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Profile.IMUserProfileSyncReq.toObject = function(includeInstance, msg) {
        var f, obj = {
            afterChangeCursor: jspb.Message.getFieldWithDefault(msg, 1, 0),
            throughChangeCursor: jspb.Message.getFieldWithDefault(msg, 2, 0),
            limit: jspb.Message.getFieldWithDefault(msg, 3, 0),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Profile.IMUserProfileSyncReq}
 */ proto.IM.Profile.IMUserProfileSyncReq.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Profile.IMUserProfileSyncReq;
    return proto.IM.Profile.IMUserProfileSyncReq.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Profile.IMUserProfileSyncReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Profile.IMUserProfileSyncReq}
 */ proto.IM.Profile.IMUserProfileSyncReq.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint64();
                msg.setAfterChangeCursor(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint64();
                msg.setThroughChangeCursor(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setLimit(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Profile.IMUserProfileSyncReq.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Profile.IMUserProfileSyncReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Profile.IMUserProfileSyncReq.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAfterChangeCursor();
    if (f !== 0) {
        writer.writeUint64(1, f);
    }
    f = message.getThroughChangeCursor();
    if (f !== 0) {
        writer.writeUint64(2, f);
    }
    f = message.getLimit();
    if (f !== 0) {
        writer.writeUint32(3, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * optional uint64 after_change_cursor = 1;
 * @return {number}
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.getAfterChangeCursor = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Profile.IMUserProfileSyncReq} returns this
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.setAfterChangeCursor = function(value) {
    return jspb.Message.setProto3IntField(this, 1, value);
};
/**
 * optional uint64 through_change_cursor = 2;
 * @return {number}
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.getThroughChangeCursor = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Profile.IMUserProfileSyncReq} returns this
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.setThroughChangeCursor = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional uint32 limit = 3;
 * @return {number}
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.getLimit = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Profile.IMUserProfileSyncReq} returns this
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.setLimit = function(value) {
    return jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Profile.IMUserProfileSyncReq} returns this
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Profile.IMUserProfileSyncReq} returns this
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Profile.IMUserProfileSyncReq.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.IM.Profile.IMUserProfileSyncRsp.repeatedFields_ = [
    1
];
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Profile.IMUserProfileSyncRsp.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Profile.IMUserProfileSyncRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Profile.IMUserProfileSyncRsp.toObject = function(includeInstance, msg) {
        var f, obj = {
            changedUsersList: jspb.Message.toObjectList(msg.getChangedUsersList(), IM_BaseDefine_pb.UserIdentityRef.toObject, includeInstance),
            nextChangeCursor: jspb.Message.getFieldWithDefault(msg, 2, 0),
            throughChangeCursor: jspb.Message.getFieldWithDefault(msg, 3, 0),
            hasMore: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
            fullSnapshotRequired: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
            attachData: msg.getAttachData_asB64()
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Profile.IMUserProfileSyncRsp}
 */ proto.IM.Profile.IMUserProfileSyncRsp.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Profile.IMUserProfileSyncRsp;
    return proto.IM.Profile.IMUserProfileSyncRsp.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Profile.IMUserProfileSyncRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Profile.IMUserProfileSyncRsp}
 */ proto.IM.Profile.IMUserProfileSyncRsp.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new IM_BaseDefine_pb.UserIdentityRef;
                reader.readMessage(value, IM_BaseDefine_pb.UserIdentityRef.deserializeBinaryFromReader);
                msg.addChangedUsers(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint64();
                msg.setNextChangeCursor(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint64();
                msg.setThroughChangeCursor(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setHasMore(value);
                break;
            case 5:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setFullSnapshotRequired(value);
                break;
            case 20:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAttachData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Profile.IMUserProfileSyncRsp.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Profile.IMUserProfileSyncRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Profile.IMUserProfileSyncRsp.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getChangedUsersList();
    if (f.length > 0) {
        writer.writeRepeatedMessage(1, f, IM_BaseDefine_pb.UserIdentityRef.serializeBinaryToWriter);
    }
    f = message.getNextChangeCursor();
    if (f !== 0) {
        writer.writeUint64(2, f);
    }
    f = message.getThroughChangeCursor();
    if (f !== 0) {
        writer.writeUint64(3, f);
    }
    f = message.getHasMore();
    if (f) {
        writer.writeBool(4, f);
    }
    f = message.getFullSnapshotRequired();
    if (f) {
        writer.writeBool(5, f);
    }
    f = /** @type {!(string|Uint8Array)} */ jspb.Message.getField(message, 20);
    if (f != null) {
        writer.writeBytes(20, f);
    }
};
/**
 * repeated IM.BaseDefine.UserIdentityRef changed_users = 1;
 * @return {!Array<!proto.IM.BaseDefine.UserIdentityRef>}
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.getChangedUsersList = function() {
    return /** @type{!Array<!proto.IM.BaseDefine.UserIdentityRef>} */ jspb.Message.getRepeatedWrapperField(this, IM_BaseDefine_pb.UserIdentityRef, 1);
};
/**
 * @param {!Array<!proto.IM.BaseDefine.UserIdentityRef>} value
 * @return {!proto.IM.Profile.IMUserProfileSyncRsp} returns this
*/ proto.IM.Profile.IMUserProfileSyncRsp.prototype.setChangedUsersList = function(value) {
    return jspb.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.IM.BaseDefine.UserIdentityRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.IM.BaseDefine.UserIdentityRef}
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.addChangedUsers = function(opt_value, opt_index) {
    return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.IM.BaseDefine.UserIdentityRef, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.IM.Profile.IMUserProfileSyncRsp} returns this
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.clearChangedUsersList = function() {
    return this.setChangedUsersList([]);
};
/**
 * optional uint64 next_change_cursor = 2;
 * @return {number}
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.getNextChangeCursor = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Profile.IMUserProfileSyncRsp} returns this
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.setNextChangeCursor = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
/**
 * optional uint64 through_change_cursor = 3;
 * @return {number}
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.getThroughChangeCursor = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Profile.IMUserProfileSyncRsp} returns this
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.setThroughChangeCursor = function(value) {
    return jspb.Message.setProto3IntField(this, 3, value);
};
/**
 * optional bool has_more = 4;
 * @return {boolean}
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.getHasMore = function() {
    return /** @type {boolean} */ jspb.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.IM.Profile.IMUserProfileSyncRsp} returns this
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.setHasMore = function(value) {
    return jspb.Message.setProto3BooleanField(this, 4, value);
};
/**
 * optional bool full_snapshot_required = 5;
 * @return {boolean}
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.getFullSnapshotRequired = function() {
    return /** @type {boolean} */ jspb.Message.getBooleanFieldWithDefault(this, 5, false);
};
/**
 * @param {boolean} value
 * @return {!proto.IM.Profile.IMUserProfileSyncRsp} returns this
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.setFullSnapshotRequired = function(value) {
    return jspb.Message.setProto3BooleanField(this, 5, value);
};
/**
 * optional bytes attach_data = 20;
 * @return {string}
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.getAttachData = function() {
    return /** @type {string} */ jspb.Message.getFieldWithDefault(this, 20, "");
};
/**
 * optional bytes attach_data = 20;
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {string}
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.getAttachData_asB64 = function() {
    return /** @type {string} */ jspb.Message.bytesAsB64(this.getAttachData());
};
/**
 * optional bytes attach_data = 20;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAttachData()`
 * @return {!Uint8Array}
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.getAttachData_asU8 = function() {
    return /** @type {!Uint8Array} */ jspb.Message.bytesAsU8(this.getAttachData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.IM.Profile.IMUserProfileSyncRsp} returns this
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.setAttachData = function(value) {
    return jspb.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IM.Profile.IMUserProfileSyncRsp} returns this
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.clearAttachData = function() {
    return jspb.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Profile.IMUserProfileSyncRsp.prototype.hasAttachData = function() {
    return jspb.Message.getField(this, 20) != null;
};
if (jspb.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IM.Profile.IMUserProfileChangedNotify.prototype.toObject = function(opt_includeInstance) {
        return proto.IM.Profile.IMUserProfileChangedNotify.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IM.Profile.IMUserProfileChangedNotify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Profile.IMUserProfileChangedNotify.toObject = function(includeInstance, msg) {
        var f, obj = {
            changedUser: (f = msg.getChangedUser()) && IM_BaseDefine_pb.UserIdentityRef.toObject(includeInstance, f),
            changeCursor: jspb.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) {
            obj.$jspbMessageInstance = msg;
        }
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IM.Profile.IMUserProfileChangedNotify}
 */ proto.IM.Profile.IMUserProfileChangedNotify.deserializeBinary = function(bytes) {
    var reader = new jspb.BinaryReader(bytes);
    var msg = new proto.IM.Profile.IMUserProfileChangedNotify;
    return proto.IM.Profile.IMUserProfileChangedNotify.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IM.Profile.IMUserProfileChangedNotify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IM.Profile.IMUserProfileChangedNotify}
 */ proto.IM.Profile.IMUserProfileChangedNotify.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) {
            break;
        }
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new IM_BaseDefine_pb.UserIdentityRef;
                reader.readMessage(value, IM_BaseDefine_pb.UserIdentityRef.deserializeBinaryFromReader);
                msg.setChangedUser(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint64();
                msg.setChangeCursor(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IM.Profile.IMUserProfileChangedNotify.prototype.serializeBinary = function() {
    var writer = new jspb.BinaryWriter();
    proto.IM.Profile.IMUserProfileChangedNotify.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IM.Profile.IMUserProfileChangedNotify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IM.Profile.IMUserProfileChangedNotify.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getChangedUser();
    if (f != null) {
        writer.writeMessage(1, f, IM_BaseDefine_pb.UserIdentityRef.serializeBinaryToWriter);
    }
    f = message.getChangeCursor();
    if (f !== 0) {
        writer.writeUint64(2, f);
    }
};
/**
 * optional IM.BaseDefine.UserIdentityRef changed_user = 1;
 * @return {?proto.IM.BaseDefine.UserIdentityRef}
 */ proto.IM.Profile.IMUserProfileChangedNotify.prototype.getChangedUser = function() {
    return /** @type{?proto.IM.BaseDefine.UserIdentityRef} */ jspb.Message.getWrapperField(this, IM_BaseDefine_pb.UserIdentityRef, 1);
};
/**
 * @param {?proto.IM.BaseDefine.UserIdentityRef|undefined} value
 * @return {!proto.IM.Profile.IMUserProfileChangedNotify} returns this
*/ proto.IM.Profile.IMUserProfileChangedNotify.prototype.setChangedUser = function(value) {
    return jspb.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.IM.Profile.IMUserProfileChangedNotify} returns this
 */ proto.IM.Profile.IMUserProfileChangedNotify.prototype.clearChangedUser = function() {
    return this.setChangedUser(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IM.Profile.IMUserProfileChangedNotify.prototype.hasChangedUser = function() {
    return jspb.Message.getField(this, 1) != null;
};
/**
 * optional uint64 change_cursor = 2;
 * @return {number}
 */ proto.IM.Profile.IMUserProfileChangedNotify.prototype.getChangeCursor = function() {
    return /** @type {number} */ jspb.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.IM.Profile.IMUserProfileChangedNotify} returns this
 */ proto.IM.Profile.IMUserProfileChangedNotify.prototype.setChangeCursor = function(value) {
    return jspb.Message.setProto3IntField(this, 2, value);
};
goog.object.extend(exports, proto.IM.Profile);

})();

export default module.exports;
